import NoResults from 'components/NoResults'
import Spinner from 'components/Spinner'
import Table from 'components/Table'
import { isEmpty } from 'lodash'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Transaction } from 'types/transactions'
import InnerWrapper from '../InnerWrapper'
import TransactionItem from './TransctionItem'
import TransactionFilter from './TransactionFilter'
import useTransactions from './useTransactions'

const NoResultsMessage =
  <NoResults
    noImage
    subtitle="Only the most recent 13 months transactions are displayed. Try setting the start date and end date to find what you are looking for."
  />

const TRANSACTION_COLUMNS = [
  'Trans Date',
  'Processed Date',
  'Trans Id',
  'Ext Trans Id',
  'Trans Card',
  'Merchant',
  'Trans Type',
  'Account',
  'CR Value',
  'Loyalty Value',
  'Purchase Value',
]

function Transactions(): React.ReactElement {
  const { traderId } = useParams()
  const [transactionFetchLimitError, setTransactionFetchLimitError] =
    useState(false)
  const [, setMerchantFetchLimitError] = useState(false)
  const [offset, setOffset] = useState(0)
  const [perPage] = useState(10)
  const [pageCount, setPageCount] = useState(0)
  const [postData, setPostData] = useState<Transaction[]>([])
  const [currentPage, setCurrentPage] = useState(1)
  const { transactions, transactionsLoading } = useTransactions({
    memberTraderId: String(traderId),
  })

  useEffect(() => {
    if (transactions) {
      const slice = transactions.slice(offset, offset + perPage)
      setPostData(slice)
      setPageCount(Math.ceil(transactions.length / perPage))
    }
  }, [offset, perPage, transactions])

  function handlePageClick({ selected }: { selected: number }): void {
    setOffset(selected * perPage)
    setCurrentPage(selected + 1)
  }

  return (
    <InnerWrapper title="Transactions">
      <TransactionFilter />

      {transactionFetchLimitError ? (
        <NoResults
          header="Failed to load data"
          subtitle="Please refresh the page and try again, or contact
        your system administrator"
          noImage
        />
      ) : transactionsLoading ? (
        <>
          <NoResults header="Loading" subtitle="Fetching data" noImage />
          <Spinner />
        </>
      ) : (
        <>
          {isEmpty(transactions) ? (
            NoResultsMessage
          ) : (
            <>
              <Table
                columns={TRANSACTION_COLUMNS}
                data={transactions}
                pageCount={pageCount}
                currentPage={currentPage}
                perPage={perPage}
                onPageChange={handlePageClick}
                itemCount={postData.length}
                showActions
              >
                {postData.map((item: Transaction) => (
                  <TransactionItem key={item.transactionId} transaction={item} />
                ))}

              </Table>
              <p className='text-right font-light'>Up to 500 transactions are displayed.</p>
            </>
          )}
        </>
      )}
    </InnerWrapper>
  )
}

export default Transactions
